var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import JSONSerializer from '@ember-data/serializer/json';
import { underscore } from '@ember/string';
import { inject as service } from '@ember/service';
let Fragment = (_class = class Fragment extends JSONSerializer {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "catalog", _descriptor, this);
  }
  keyForAttribute(attr) {
    return underscore(attr);
  }
  serializeAttribute(snapshot, json, key, attribute) {
    // Ember data coerces undefined values to null, but some APIs treat
    // those values differently.
    if (snapshot.attr(key) === undefined) {
      return;
    }

    // Only serialize enums to their proto equivalent when crafting RPC requests.
    // Consumers can set `serializeForRpc` on the catalog service when proto enum serialization is desired.
    if (this.catalog.serializeForRpc && attribute.options?.protoEnum) {
      const protoEnum = attribute.options.protoEnum;
      const value = snapshot.attr(key);
      const serializedValue = Array.isArray(value) ? value.map(v => this._serializeValue(v, protoEnum)) : this._serializeValue(value, protoEnum);

      // Directly modifying the json param is how Ember's own JSON serializer works
      // eslint-disable-next-line no-param-reassign
      json[this.keyForAttribute(key)] = serializedValue;
    } else {
      super.serializeAttribute(snapshot, json, key, attribute);
    }
  }

  /**
   * Serializes the value based given the `protoEnum` passed and the type of the value. In general,
   * this will take any string representations of enum values and convert them to their numerical equivalents.
   * Thus, if we encounter a number, that is assumed to already be the desired numerical representation
   * and no conversion takes place.
   */
  _serializeValue(value, protoEnum) {
    return typeof value === 'number' ? value : protoEnum[value];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "catalog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Fragment as default };